<script setup lang="ts"></script>

<template>
  <div class="catalog-route">
    <NuxtPage />
  </div>
</template>
